// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Entity Type
 * @export
 * @enum {string}
 */
export var EntityType;
(function (EntityType) {
    EntityType["Manager"] = "Manager";
    EntityType["Asset"] = "Asset";
    EntityType["Portfolio"] = "Portfolio";
    EntityType["Fund"] = "Fund";
    EntityType["Market"] = "Market";
    EntityType["FundSeries"] = "FundSeries";
})(EntityType || (EntityType = {}));
export function EntityTypeFromJSON(json) {
    return json;
}
export function EntityTypeToJSON(value) {
    return value;
}
